const React = require('react');
const {
    ManagedFormContainer
} = require('hooks/useFormPrimitives');
const useUserInputsController = require('./useUserInputsController');
const UserInputsRenderer = require('./UserInputsRenderer');

module.exports = function UserInputsContainer(props) {

    return <ManagedFormContainer
        controller={useUserInputsController(props)}
        Renderer={UserInputsRenderer}
    />;
};
